import { Icon } from "@iconify/react/dist/iconify.js";

const BooleanIcon = ({ value }) => {
  return (
    <Icon
      icon={value ? "solar:shield-check-broken" : "solar:shield-cross-broken"}
      className={`text-${value ? "success" : "danger"} text-2xxl`}
    />
  );
};

export default BooleanIcon;
